import { render, staticRenderFns } from "./College.vue?vue&type=template&id=658aac74&scoped=true&"
import script from "./College.vue?vue&type=script&lang=js&"
export * from "./College.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658aac74",
  null
  
)

export default component.exports